module.exports = __webpack_public_path__ + "static/media/YM54_6.a9e847b4.jpg";